import { render, staticRenderFns } from "./SocialSharing.vue?vue&type=template&id=3590e428&"
import script from "./SocialSharing.vue?vue&type=script&lang=js&"
export * from "./SocialSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports